export interface NewsItem {
  id: string;
  title: string;
  date: string;
  category: string;
  excerpt: string;
  relatedId: string;
}

export const newsList: NewsItem[] = [
  {
    id: 'n01',
    title: '《第七次日落》口碑解禁：年度最具野心的科幻作',
    date: '2026-10-16',
    category: '影讯',
    excerpt: '七个太阳、七次遗忘，导演艾登·霍尔用两小时二十六分钟讲完了一个关于记忆与权力的寓言，首映场观众散场后仍在讨论最后一幕。',
    relatedId: 'm03',
  },
  {
    id: 'n02',
    title: '《春风不渡》定档十月，古装剧市场再迎高配置',
    date: '2026-10-15',
    category: '剧集',
    excerpt: '全 40 集古装剧确认播出档期，主创表示服化道耗时一年半，边关实景拍摄超过四个月。',
    relatedId: 'm04',
  },
  {
    id: 'n03',
    title: '国漫《山海记·归墟》开播三天热度破万',
    date: '2026-10-14',
    category: '动漫',
    excerpt: '改编自《山海经》残卷的动画系列以水墨融合三维的视觉风格获得大量讨论，第二季已进入筹备阶段。',
    relatedId: 'm14',
  },
  {
    id: 'n04',
    title: '《长夜锈河》剧组公布导演剪辑版时长',
    date: '2026-10-12',
    category: '影讯',
    excerpt: '相比院线版多出十八分钟，主要补充了证人证词的细节与结尾的一场夜谈，预计年底上线。',
    relatedId: 'm01',
  },
  {
    id: 'n05',
    title: '《雪线之上》主创谈拍摄：在四千米驻守一整年',
    date: '2026-10-11',
    category: '纪录片',
    excerpt: '摄制组透露片中雪豹镜头为自然光实拍，全片几乎不使用解说，希望把判断交给观众。',
    relatedId: 'm28',
  },
  {
    id: 'n06',
    title: '《我们的乐队梦》收官：三支乐队拿到巡演合约',
    date: '2026-10-09',
    category: '综艺',
    excerpt: '节目以现场收音和原创作品为特色，收官夜的三场演出被观众称为“年度最真诚的舞台”。',
    relatedId: 'm29',
  },
  {
    id: 'n07',
    title: '《海雾中的灯塔》确认引进，冬日档期上画',
    date: '2026-10-07',
    category: '影讯',
    excerpt: '森川遥执导的治愈系作品在多个影展获得好评，引进版本保留了原声音乐与全部片尾字幕。',
    relatedId: 'm02',
  },
  {
    id: 'n08',
    title: '《铁线莲计划》曝新预告：四十分钟一镜到底的动作戏',
    date: '2026-10-05',
    category: '影讯',
    excerpt: '港式动作片回归硬派路线，导演雷振邦称整条街的灯光都由剧组重新布线，只为一个连续镜头。',
    relatedId: 'm06',
  },
  {
    id: 'n09',
    title: '《流光之城》编剧访谈：三分钟的时间差从何而来',
    date: '2026-10-03',
    category: '剧集',
    excerpt: '编剧延智勋表示灵感来自自己住过的写字楼，“所有楼层的钟都快三分钟，没有人知道为什么”。',
    relatedId: 'm09',
  },
];

export interface TopicItem {
  id: string;
  title: string;
  subtitle: string;
  description: string;
  cover: string;
  mediaIds: string[];
  accent: string;
}

export const topicList: TopicItem[] = [
  {
    id: 't01',
    title: '2026 必看电影',
    subtitle: '编辑精选 · 12 部',
    description: '从科幻到悬疑，从荒原到海岛，这一年最值得走进影院的十二部作品，我们把它们排好了顺序。',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20cinema%20collection%20cover%20with%20abstract%20layered%20warm%20amber%20and%20deep%20green%20cinematic%20shapes%2C%20subtle%20light%20leaks%2C%20film%20strip%20texture%2C%20minimal%20modern%20composition%2C%20no%20text&width=1200&height=700&seq=boluomi-topic-t01&orientation=landscape',
    mediaIds: ['m03', 'm01', 'm14', 'm04', 'm28', 'm29'],
    accent: 'primary',
  },
  {
    id: 't02',
    title: '国际影视节精选',
    subtitle: '影展回顾 · 8 部',
    description: '从柏林到戛纳，今年在各大影展上被反复提及的八部作品，以及它们为什么值得被看见。',
    cover: 'https://readdy.ai/api/search-image?query=Artistic%20film%20festival%20collection%20cover%20with%20abstract%20amber%20spotlight%20beams%20across%20a%20dark%20green%20theatre%20space%2C%20soft%20grain%2C%20minimal%20editorial%20composition%2C%20no%20text&width=1200&height=700&seq=boluomi-topic-t02&orientation=landscape',
    mediaIds: ['m13', 'm20', 'm12', 'm21', 'm23', 'm25'],
    accent: 'accent',
  },
  {
    id: 't03',
    title: '深夜治愈清单',
    subtitle: '凌晨两点 · 10 部',
    description: '睡不着的时候，适合放一部不着急的电影。这里有面点、有海边、有一盏一直亮着的灯。',
    cover: 'https://readdy.ai/api/search-image?query=Cozy%20late-night%20collection%20cover%20with%20soft%20amber%20lamp%20glow%20on%20a%20quiet%20dark%20green%20street%2C%20gentle%20bokeh%2C%20warm%20minimal%20editorial%20composition%2C%20no%20text&width=1200&height=700&seq=boluomi-topic-t03&orientation=landscape',
    mediaIds: ['m25', 'm27', 'm07', 'm02', 'm17', 'm10'],
    accent: 'secondary',
  },
  {
    id: 't04',
    title: '国产剧集进阶之路',
    subtitle: '深度专题 · 6 部',
    description: '从年代群像到现实题材，梳理近三年国产剧在叙事与制作上的变化轨迹。',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20collection%20cover%20with%20abstract%20ink%20wash%20mountains%20in%20warm%20amber%20and%20jade%20green%2C%20soft%20paper%20texture%2C%20minimal%20editorial%20composition%2C%20no%20text&width=1200&height=700&seq=boluomi-topic-t04&orientation=landscape',
    mediaIds: ['m24', 'm15', 'm05', 'm22', 'm04', 'm01'],
    accent: 'primary',
  },
];

export const siteIntro = {
  name: '菠萝蜜网',
  slogan: '看见每一部值得被记住的影视作品',
  description:
    '菠萝蜜网是一个专注于电影、电视剧资讯与推荐的内容平台。我们不提供在线播放，而是把力气花在整理与筛选上：每天更新影视动态，按类型、地区、年份把作品归类清楚，用尽量少的噪音帮你找到真正想看的那一部。',
  stats: [
    { label: '收录影视作品', value: '12,800+' },
    { label: '每日更新资讯', value: '86 条' },
    { label: '编辑推荐专题', value: '240 期' },
    { label: '覆盖地区', value: '26 个' },
  ],
};